export default __webpack_public_path__ + "static/corazon-creciente-2e7ca321978d0e7faab72fba52ade25f.png";